import {styled} from "@mui/material";
import {hexToRGBA} from "../utils/hexToRGBA";

export const PaymentOptionList = styled('div')`
  display: flex;
  justify-content: space-between;
  // Should not use overflow: scroll because some of the browsers will have a disabled scroll bar forever.
`;

export const PaymentOption = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'borderColor'
})(({ selected, borderColor }) => ({
  border: selected ? `2px solid ${borderColor}` : 'none',
  padding: '10px 20px',
  position: 'relative',
  flexGrow: 1,
  flexBasis: '10%',
  height: '90px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  borderRadius: '10px',
  boxShadow: `1px 3px 4px 0px ${selected ? hexToRGBA(borderColor, 0.2) : 'rgba(0, 0, 0, 0.10)'}`,
  background: '#FFF',
  marginRight: '12px',
  '&:last-child': {
    marginRight: '0px'
  }
}));

export const PaymentOptionImage = styled('img')`
  height: 30px;
  margin-right: auto;
`;


export const PaymentOptionText = styled('div')`
  color: #10253E;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 600;
`;

export const PaymentDetails = styled('div')`
  padding: 20px 0;
`;

export const PaymentHiddenWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'show' // Prevent 'show' from being passed to DOM
})(({ show }) => ({
  display: show ? 'block' : 'none',
  textAlign: 'center',
}));

export const PaymentContent = styled('div')`
  display: flex;
  align-items: center;
  padding: 30px 0;

  & img {
    width: 134px;
    height: 92px;
  }

  & div {
    margin-left: 20px;
    font-size: 18px;
    text-align: left;
  }
`;

export const SurchargeAmountWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'textAlign'
})(({ textAlign }) => ({
  color: 'rgba(84, 84, 84, 0.56)',
  marginTop: '8px',
  fontSize: '13px',
  paddingLeft: '5px',
  textAlign: textAlign || 'center',
}));
